"use client";
import Link from "next/link";
import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const SettingsComponent = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="block sm:w-[30vw]  w-full border-white/75 h-full dark:border-white/25 lg:bg-settings-sidepanel shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1.9px] text-[#020817] dark:text-[#F8FAFC] lg:pr-2 p-1">
      <div className="flex flex-col bg-settings-header h-fit rounded-2xl  p-3 mb-3">
        <h2 className="text-xl font-bold mb-1">Settings</h2>
        <p className="text-xs text-muted-foreground ">
          Manage your account settings and preferences.
        </p>
      </div>

      {[
        { title: "My Account", link: "/settings/my-account" },
        // { title: 'Security and account access', link: '/settings/security' },
        { title: "Privacy and Safety", link: "/settings/privacy-safety" },
      ].map((item, index) => (
        <Link key={index} href={item.link} className="block">
          <div
            className={` hover:scale-[1.02] hover:w-full mb-2 py-4 px-4 cursor-pointer border-r-2 rounded-2xl
                        ${selectedIndex === index ? "bg-settings-activeButton text-white  dark:text-black font-semibold hover:text-white" : "bg-white/25 dark:bg-white/10 hover:bg-white/30  dark:hover:bg-white/20 text-black dark:text-white"} 
                        hover:border-blue-500 transition-all flex items-center justify-between`}
            onClick={() => setSelectedIndex(index)}
          >
            <span>{item.title}</span>
            <ChevronRight className="w-5 h-5 text-muted-foreground" />
          </div>
        </Link>
      ))}
    </div>
  );
};

export default SettingsComponent;
